import React, { useState, useEffect } from 'react';
import { Button, Spinner, Alert, Modal, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';
import { settings } from '../../settings';

export default function DGTH_supplier_invoices_received({ entity, data, setData, searchObj, setSearchObj, refreshData }) {

    const [fetchLoading, setFetchLoading] = useState(false);
    const [fetchResult, setFetchResult] = useState(null);
    const [showResultModal, setShowResultModal] = useState(false);
    const [countLoading, setCountLoading] = useState(false);
    const [counts, setCounts] = useState(null);

    useEffect(() => {
        loadCounts();
    }, []);

    async function loadCounts() {
        setCountLoading(true);
        try {
            const res = await ApiManager.sendAuthenticatedRequest('/custom/count_new_received_invoices', {});
            if (res.success === 1) {
                setCounts(res);
            }
        } catch (err) {
            console.error('Errore conteggio fatture:', err);
        } finally {
            setCountLoading(false);
        }
    }

    async function fetchReceivedInvoices() {
        if (fetchLoading) return;
        setFetchLoading(true);
        setFetchResult(null);
        try {
            const res = await ApiManager.sendAuthenticatedRequest('/custom/fetch_received_invoices', {});
            if (res.success === 1) {
                setFetchResult(res);
                setShowResultModal(true);
                toast.success(res.message || 'Fatture passive scaricate', { theme: 'colored' });
                loadCounts();
                if (typeof refreshData === 'function') refreshData();
            } else {
                toast.error(res.message || 'Errore scaricamento fatture passive', { theme: 'colored' });
            }
        } catch (err) {
            toast.error('Errore: ' + err.message, { theme: 'colored' });
        } finally {
            setFetchLoading(false);
        }
    }

    if (!settings.fatturazione) return <></>;

    return (
        <>
            <div className='d-flex flex-row gap-2 align-items-center flex-wrap'>
                <Button className='my-1' variant='primary' size='sm' disabled={fetchLoading} onClick={fetchReceivedInvoices}>
                    {fetchLoading ? (
                        <><Spinner animation='border' size='sm' className='me-2' />Scaricamento in corso...</>
                    ) : (
                        <><FontAwesomeIcon icon='download' className='me-1' />Scarica fatture passive da SDI</>
                    )}
                </Button>

                {countLoading ? (
                    <Spinner animation='border' size='sm' />
                ) : counts && (
                    <div className='d-flex flex-row gap-2 align-items-center'>
                        {counts.newOnAruba > 0 && (
                            <Badge bg='warning' text='dark'>
                                <FontAwesomeIcon icon='cloud-arrow-down' className='me-1' />
                                {counts.newOnAruba} nuove su Aruba
                            </Badge>
                        )}
                        {counts.pendingInDb > 0 && (
                            <Badge bg='info'>
                                <FontAwesomeIcon icon='clock' className='me-1' />
                                {counts.pendingInDb} da elaborare
                            </Badge>
                        )}
                        {counts.newOnAruba === 0 && counts.pendingInDb === 0 && (
                            <Badge bg='success'>
                                <FontAwesomeIcon icon='check' className='me-1' />
                                Tutto aggiornato
                            </Badge>
                        )}
                    </div>
                )}

                <Button variant='outline-secondary' size='sm' className='my-1' onClick={loadCounts} disabled={countLoading}>
                    <FontAwesomeIcon icon='rotate' />
                </Button>
            </div>

            <Modal show={showResultModal} onHide={() => setShowResultModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Fatture passive scaricate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {fetchResult && (
                        <Alert variant='success' className='mb-0'>
                            <p className='mb-1'>{fetchResult.message}</p>
                            {fetchResult.imported != null && <p className='mb-0'>Nuove fatture importate: <strong>{fetchResult.imported}</strong></p>}
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='primary' onClick={() => setShowResultModal(false)}>Chiudi</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
